import endpoints from '@app/src/api/endpoints'
import { FetchKey } from '@app/src/api/fetchHooks'
import { useCreateResource } from '@app/src/api/updateHooks'
import { useAiJobs } from '@app/src/context/AiJobsContext'
import useErrorNotification from '@app/src/hooks/errorNotification'
import { SCRAPER_IS_RUNNING_QUERY_KEY } from '@app/src/pages/Dashboards/ScrapedAnswerByDataFound'
import { useQueryClient } from '@tanstack/react-query'

type ScheduleScreeningPayload = {
  providerIds: number[]
  templateIds: number[]
  sendEmailOnComplete: boolean
}

export const useScheduleScreening = () => {
  const { showErrorNotification } = useErrorNotification()
  const { mutateAsync: sendScheduleScreening, isPending: isScheduling } = useCreateResource<ScheduleScreeningPayload>()
  const queryClient = useQueryClient()
  const { addJob } = useAiJobs()

  const scheduleScreening = async (payload: ScheduleScreeningPayload) => {
    await sendScheduleScreening(
      {
        url: endpoints.scheduleScreening,
        body: payload,
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({ queryKey: [SCRAPER_IS_RUNNING_QUERY_KEY] })
          queryClient.invalidateQueries({ queryKey: [FetchKey.ResponseScraping] })
          addJob({
            type: 'screening',
            inProgressCount: payload.providerIds.length,
          })
        },
        onError: error => {
          showErrorNotification({ requestError: error, disableAutoClose: true })
        },
      },
    )
  }

  return { scheduleScreening, isScheduling }
}
